import { useSlots as k, computed as g, createElementBlock as n, openBlock as t, normalizeClass as d, createElementVNode as u, createCommentVNode as o, createBlock as v, toDisplayString as m, renderSlot as x, unref as C, Fragment as b, renderList as w } from "vue";
import j from "../link/link.vue.js";
import { useTracking as B } from "../../composables/useTracking.js";
/* empty css              */
import _ from "../../_virtual/_plugin-vue_export-helper.js";
const z = ["textContent"], S = ["textContent"], L = {
  key: 2,
  class: "ds-margin-top-12 ds-text"
}, $ = {
  key: 0,
  class: "ds-lg-grid__col--1"
}, A = ["src", "alt", "loading"], f = "DsLogoBar", E = /* @__PURE__ */ Object.assign({
  name: f
}, {
  __name: "logo-bar",
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    link: {
      type: Object,
      default: null
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    orientation: {
      type: String,
      default: "vertical",
      validator: (e) => ["vertical", "horizontal"].includes(e)
    },
    /**
     * Logo items, array of objects with image src and alt text
     */
    items: {
      type: Array,
      required: !0,
      validator: (e) => e.every((l) => typeof l == "object" && ["src", "name"].every((s) => s in l))
    },
    /**
     * Aligns logo items center on the horizontal axis
     */
    alignCenter: {
      type: Boolean,
      default: !1
    },
    /**
     * Aligns logo items to the end of the container
     */
    alignLogosFlexEnd: {
      type: Boolean,
      default: !1
    },
    /**
     * SPECIAL CASE - used in `/customers`, where the logobar is used as a Hero - center aligns in mobile and tablet
     */
    useAsHero: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const l = e, { trackingDataProvided: s } = B();
    k();
    const i = g(() => l.orientation === "horizontal"), y = g(() => {
      var a, r;
      if (l.alignCenter && !i.value) {
        if ([7, 8].includes((a = l.items) == null ? void 0 : a.length))
          return "ds-logo-bar__items--width-small";
        if ([9, 10].includes((r = l.items) == null ? void 0 : r.length))
          return "ds-logo-bar__items--width-medium";
      }
      return null;
    });
    return (a, r) => (t(), n("div", {
      class: d(["ds-logo-bar", { "ds-text-align-center": e.alignCenter, "ds-grid ds-align-items-center": i.value }])
    }, [
      u("div", {
        class: d({
          "ds-grid__col ds-grid__col--12 ds-lg-grid__col--5": i.value,
          "ds-grid__col ds-grid__col--12 ds-lg-grid__col--8 ds-lg-grid__col--offset-2": !i.value && e.alignCenter,
          "ds-logo-bar__hero": e.useAsHero
        })
      }, [
        e.title && e.useAsHero ? (t(), n("h1", {
          key: 0,
          class: "ds-heading-xlarge",
          "data-j-hero-title": "",
          textContent: m(e.title)
        }, null, 8, z)) : e.title ? (t(), n("h2", {
          key: 1,
          class: "ds-heading",
          "data-j-title": "",
          textContent: m(e.title)
        }, null, 8, S)) : o("", !0),
        a.$slots.description ? (t(), n("div", L, [
          x(a.$slots, "description", {}, void 0, !0)
        ])) : o("", !0),
        e.link ? (t(), v(j, {
          key: 3,
          "tracking-data": { "component-name": f, text: e.link.title, title: e.title, ...C(s) },
          url: e.link.url,
          "open-in-new-window": e.link.openInNewWindow,
          nuxt: e.link.nuxt,
          content: e.link.title,
          "icon-right": { name: "chevron-right-small", category: "arrows" },
          class: "ds-margin-top-24"
        }, null, 8, ["tracking-data", "url", "open-in-new-window", "nuxt", "content"])) : o("", !0)
      ], 2),
      i.value ? (t(), n("div", $)) : o("", !0),
      u("div", {
        class: d(["ds-logo-bar__items", [
          {
            "ds-justify-content-center": e.alignCenter,
            "ds-margin-top-48": e.title || a.$slots.description || e.link,
            "ds-grid__col ds-grid__col--12 ds-lg-grid__col--6 ds-lg-margin-top-0": i.value,
            "ds-justify-content-flex-end": e.alignLogosFlexEnd
          },
          y.value
        ]]),
        "data-j-logo-bar": ""
      }, [
        (t(!0), n(b, null, w(e.items, (c, h) => (t(), n("img", {
          key: `item-${h}`,
          class: "ds-logo-bar__image",
          src: c.src,
          alt: c.name,
          loading: e.lazy ? "lazy" : "eager",
          "data-j-item": ""
        }, null, 8, A))), 128))
      ], 2)
    ], 2));
  }
}), O = /* @__PURE__ */ _(E, [["__scopeId", "data-v-27d54926"]]);
export {
  O as default
};
